module.exports = require("./ar-JO.js");